<template>
<div>
   
    <app-header></app-header>
    <router-view></router-view>

        <!-- set progressbar -->
    <!-- <vue-progress-bar></vue-progress-bar>   -->
    <app-footer></app-footer>
       
</div>
</template>

<script>
import Header from '../components/header'
import Footer from '../components/footer'
export default {
    components: {
        "app-header": Header,
        "app-footer": Footer
    },
    name: "App"
}
</script>

<style scoped>
    /* :root {
    --animate-duration: 100ms;
    --animate-delay: 0s;
    } */
</style>